import { render, staticRenderFns } from "./packageCardV2.vue?vue&type=template&id=c114f69c"
import script from "./packageCardV2.vue?vue&type=script&lang=js"
export * from "./packageCardV2.vue?vue&type=script&lang=js"
import style0 from "./packageCardV2.vue?vue&type=style&index=0&id=c114f69c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports